"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pollAudioLevel = void 0;
const audioContext = typeof window !== 'undefined' && window.AudioContext ? new window.AudioContext() : null;
const pollAudioLevel = (config) => __awaiter(void 0, void 0, void 0, function* () {
    if (!audioContext) {
        return;
    }
    // Due to browsers' autoplay policy, the AudioContext is only active after
    // the user has interacted with your app, after which the Promise returned
    // here is resolved.
    try {
        yield audioContext.resume();
    }
    catch (err) {
        config.onError('Error resuming AudioContext', err);
        return;
    }
    function rootMeanSquare(samples) {
        const sumSq = samples.reduce((sumSq, sample) => sumSq + sample * sample, 0);
        return Math.sqrt(sumSq / samples.length);
    }
    // Create an analyser to access the raw audio samples from the microphone.
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 1024;
    analyser.smoothingTimeConstant = 0.5;
    // Connect the LocalAudioTrack's media source to the analyser.
    const stream = new MediaStream([config.track]);
    const source = audioContext.createMediaStreamSource(stream);
    source.connect(analyser);
    const samples = new Uint8Array(analyser.frequencyBinCount);
    let level = null;
    // Periodically calculate the audio level from the captured samples,
    // and if changed, call the callback with the new audio level.
    const checkLevel = () => {
        analyser.getByteFrequencyData(samples);
        const rms = rootMeanSquare(samples);
        const log2Rms = rms && Math.log2(rms);
        // Audio level ranges from 0 (silence) to 10 (loudest).
        const newLevel = Math.ceil((10 * log2Rms) / 8);
        if (level !== newLevel) {
            level = newLevel;
            config.onLevelChanged(level);
        }
        // Continue calculating the level only if the audio track is live.
        if (config.track.readyState === 'live') {
            requestAnimationFrame(checkLevel);
        }
        else {
            requestAnimationFrame(() => config.onLevelChanged(0));
        }
    };
    requestAnimationFrame(checkLevel);
});
exports.pollAudioLevel = pollAudioLevel;
//# sourceMappingURL=poll_audio_level.js.map